// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-user-label{display:flex;align-items:center}.ac-user-label--md .ac-user-label__userpic{width:4.5rem;height:4.5rem}.ac-user-label__userpic{height:2.5rem;width:2.5rem;margin-right:1.5rem}.ac-user-label__name{display:flex;flex-direction:column}\n", ""]);
// Exports
module.exports = exports;
